import { UseSWROutput, useSWR } from '~/hooks/useSWR';
import { People, TimesheetApiClient } from '~/services/Http';

export const GET_TEAM_TIMESHEET_SWR_KEY = 'TimesheetApiClient.getTeamTimesheet';

export function useGetTeamTimesheet(args: {
  employeeId: string;
  lang?: string;
  offset?: number;
  limit?: number;
  order?: People.Order22;
  treeId?: string;
  roles?: string[];
  unitIds?: number[];
}): UseSWROutput<People.TimesheetShortDto[]> {
  return useSWR(
    [
      GET_TEAM_TIMESHEET_SWR_KEY,
      args.employeeId,
      args?.lang ?? undefined,
      args?.offset ?? undefined,
      args?.limit ?? undefined,
      args?.order ?? undefined,
      args?.treeId ?? undefined,
      args?.unitIds ?? undefined,
      args?.roles ?? undefined,
    ],
    ([_, employeeId, lang, offset, limit, order, treeId, unitIds, roles]) =>
      TimesheetApiClient.getTeamTimesheet(
        employeeId,
        order,
        offset,
        limit,
        lang,
        treeId,
        roles,
        unitIds,
      ).then((r) => r.data),
  );
}
